import { render, staticRenderFns } from "./enterprises.vue?vue&type=template&id=2a0f19bc&scoped=true&"
import script from "./enterprises.vue?vue&type=script&lang=js&"
export * from "./enterprises.vue?vue&type=script&lang=js&"
import style0 from "./enterprises.vue?vue&type=style&index=0&id=2a0f19bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0f19bc",
  null
  
)

export default component.exports